import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleQR(event) {
    event.preventDefault()
    const qrSection = this.element.querySelector(".qr-section")
    qrSection.classList.toggle("device-hidden")
    const walletButtons = this.element.querySelector(".download-options")
    walletButtons.classList.toggle("device-hidden")
  }

  toggleWallet(event) {
    event.preventDefault()
    const walletButtons = this.element.querySelector(".download-options")
    walletButtons.classList.toggle("device-hidden")
    const qrSection = this.element.querySelector(".qr-section")
    qrSection.classList.toggle("device-hidden")
  }
} 